import type { BaseInputProps } from '../base'

export enum SearchSize {
  small = 's',
  medium = 'm',
}

type BaseInputPropsOmitted = 'size' | 'disabled | leadingIcon | trailingIcon | suffix'

export interface SearchInputProps extends Omit<BaseInputProps, BaseInputPropsOmitted> {
  size?: SearchSize
}
